import * as React from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import PageHeading from 'components/page/page-heading/PageHeading';

import { __t, applyTranslations } from 'utils/language';

import './ccm-offer-additional-requirements.scss';

applyTranslations(require('./ccm-offer-additional-requirements.i18n.json'));

import type {
  Campaign
} from 'types';

type Props = {
  campaign: Campaign,
  outfitGuidelineLink: string
};

const MSG_KEY = 'ccm_offer_additional_requirements';

const CcmOfferAdditionalRequirements: React.FC<Props> = ({
  campaign,
  outfitGuidelineLink
}): JSX.Element | null => {
  if (isNil(campaign.additionalRequirementsTemplate)) {
    return null;
  }

  const wrapIcon = (
    line: string
  ): React.ReactNode => (
    <React.Fragment>
      <span>
        {line.slice(0, 1)}
      </span>
      {line.slice(1)}
    </React.Fragment>
  );

  const formatTemplate = (
    template: string
  ): React.ReactNode => {
    const arr = template.split('\n');
    const lines = arr.slice(0, arr.length - 1); // remove last element (it's empty)

    return (
      <ul>
        {lines.map(line => {
          const itemClasses = classnames('ccm-offer-additional-requirements__item', {
            'ccm-offer-additional-requirements__item--divider': isEmpty(line)
          });

          return (
            <li
              key={line}
              className={itemClasses}
            >
              {wrapIcon(line)}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="ccm-offer-additional-requirements">
      <PageHeading
        heading={__t(`${MSG_KEY}.title`)}
        size="h3"
        margin="none"
        weight="bold"
      />
      <div className="ccm-offer-additional-requirements__contents">
        <div className="ccm-offer-additional-requirements__dos-donts">
          {formatTemplate(campaign.additionalRequirementsTemplate)}
        </div>
        <div className="ccm-offer-additional-requirements__guidelines">
          <div className="ccm-offer-additional-requirements__guidelines-title">
            {__t(`${MSG_KEY}.outfit_guidelines.title`)}
          </div>
          <div>
            {__t(`${MSG_KEY}.outfit_guidelines.text`)}
            <a
              href={outfitGuidelineLink}
              rel="noopener noreferrer"
              target="_blank"
              className="ccm-offer-additional-requirements__link"
            >
              {__t(`${MSG_KEY}.outfit_guidelines.link`)}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CcmOfferAdditionalRequirements;
